import { useMemo } from "react";
import type { PlanEvent, CategoryFilter } from "../../../shared/types";
import { deriveTemplate } from "../utils/derive-template";
import type { TemplateData } from "../utils/derive-template";

export function useScheduleTemplate(
  events: readonly PlanEvent[],
  categoryFilter: CategoryFilter,
): TemplateData {
  return useMemo(() => {
    const filtered =
      categoryFilter === "all"
        ? events
        : events.filter((e) => e.category === categoryFilter);
    return deriveTemplate(filtered);
  }, [events, categoryFilter]);
}
